export const farmingTags = {
  FARM: 'farm',
  FARM_INDIVIDUALS: 'farm_individuals',
};
